import { Ban, CheckCircle, MoreHorizontal, Pencil, Trash2 } from "lucide-react";
import { DropdownMenu } from "@/components/common";
import type { DropdownMenuItem } from "@/components/common/DropdownMenu";
import type { ManagedUser } from "@/types/rbac";

interface UserActionsDropdownProps {
  user: ManagedUser;
  onEdit: (user: ManagedUser) => void;
  onToggleStatus: (user: ManagedUser) => void;
  onDelete: (user: ManagedUser) => void;
  isSelf?: boolean;
  canUpdate?: boolean;
  canDelete?: boolean;
}

export function UserActionsDropdown({
  user,
  onEdit,
  onToggleStatus,
  onDelete,
  isSelf = false,
  canUpdate = true,
  canDelete = true,
}: UserActionsDropdownProps) {
  const items: DropdownMenuItem[] = [];

  if (canUpdate) {
    items.push({
      label: "Edytuj",
      icon: <Pencil size={14} />,
      onClick: () => {
        onEdit(user);
      },
    });
  }

  if (canUpdate && user.status !== "invited" && !isSelf) {
    items.push({
      label: user.status === "active" ? "Wyłącz" : "Aktywuj",
      icon:
        user.status === "active" ? (
          <Ban size={14} />
        ) : (
          <CheckCircle size={14} />
        ),
      onClick: () => {
        onToggleStatus(user);
      },
    });
  }

  if (canDelete && !isSelf) {
    items.push({
      label: "Usuń",
      icon: <Trash2 size={14} />,
      onClick: () => {
        onDelete(user);
      },
      variant: "danger",
    });
  }

  if (items.length === 0) {
    return null;
  }

  return (
    <DropdownMenu
      trigger={<MoreHorizontal size={16} aria-hidden="true" />}
      items={items}
    />
  );
}
